import React from 'react'
import clsx from 'clsx'
import styles from '../Navbar.module.scss'
import { StandardProps } from '../../../types/common'

interface NavProps extends StandardProps {
  /**
   * Whether center, or not
   */
  center?: boolean
}

export const Nav: React.FC<NavProps> = ({
  children,
  className,
  style,
  testid = 'nav',
  center,
  ...props
}) => {
  return (
    <ul
      className={clsx(
        styles['hds-nav'],
        {
          [styles['hds-navbar__primary_center']]: center,
        },
        className
      )}
      style={style}
      data-testid={testid}
      {...props}
    >
      {children}
    </ul>
  )
}
